import styled from 'styled-components';
import { media } from 'utils/media-query-helper';
import ModalWindow from './modal-window-manager';

export const Modal = styled(ModalWindow)`
  & .modalOverlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${props => props.theme.colors.overlayGrey};
    z-index: 20;
    transition: all 0.15s linear;
    overflow-x: hidden;
    overflow-y: auto;
  }

  & .ReactModal__Content {
    top: 8%;
    left: 50%;
    right: auto;
    bottom: auto;
    margin-right: -50%;
    transform: translateX(-50%);
    position: relative;
    border-radius: 6px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    background-clip: padding-box;
    padding: 40px;
    outline: 0;
    background-color: ${props => props.theme.colors.white};
    transition: all 0.3s linear;
    width: calc(100% - 30px);

    ${media.tablet`
      width:600px;
    `};
  }

  &.overlayOnly .ReactModal__Content {
    background-color: transparent;
    box-shadow: none;
  }

  &.noPadding,
  &.blueHeader {
    & .ReactModal__Content {
      padding: 0;
      div section > div {
        padding: 0;
      }
    }
  }

  &.blueHeader {
    .closeButton {
      right: 10px;
      top: 10px;
      .icon {
        color: ${props => props.theme.colors.white};
      }
    }
  }
`;

export default Modal;
